import { urlParam } from "../Common/Filters";
import { resolveFilterUpdate } from "./AttributeFilters";
import type { AttributeFilter } from "./types";

/** The URL param config for a list's attribute filters, kept as JSON, for a useFilterParams config. */
export const attributeFiltersParam = { read: urlParam.json<AttributeFilter[]>(), write: JSON.stringify };

/** The list after setting one attribute's filter, or removing it. */
export function withAttributeFilter(current: AttributeFilter[], filter: AttributeFilter, remove = false): AttributeFilter[] {
    return remove ? current.filter(f => f.attributeId !== filter.attributeId) : resolveFilterUpdate(filter, current);
}
